import React from 'react';
import { Star } from 'lucide-react';
const PRESS_LOGOS = ['VOGUE', 'ELLE', 'THE CUT', "HARPER'S BAZAAR", 'NEW YORK TIMES', "WOMEN'S HEALTH", 'GLAMOUR'];
export function SocialProof() {
  // Duplicate for seamless loop
  const logos = [...PRESS_LOGOS, ...PRESS_LOGOS];
  return <section className="w-full bg-orla-sienna py-32 md:py-[128px] px-6" data-id="element-291">
      <div className="max-w-[1240px] mx-auto" data-id="element-292">
        {/* Main Heading */}
        <h2 className="font-display font-black text-[32px] md:text-[48px] text-orla-bone tracking-[-0.02em] leading-[1.1] text-center max-w-[880px] mx-auto mb-12" data-id="element-293">
          Join 40,000+ women who have found relief, support, and a real doctor
          in Orla.
        </h2>

        {/* Trustpilot Row */}
        <div className="flex items-center justify-center gap-4 mb-16" data-id="element-294">
          <div className="flex items-center gap-2" data-id="element-295">
            <span className="font-body font-black text-[18px] text-orla-bone" data-id="element-296">
              Trustpilot
            </span>
            <Star className="w-4 h-4 fill-orla-saffron text-orla-saffron" data-id="element-297" />
          </div>
          <div className="flex gap-1" data-id="element-298">
            {[...Array(5)].map((_, i) => <Star key={i} className="w-7 h-7 fill-orla-saffron text-orla-saffron" data-id="element-299" />)}
          </div>
          <span className="font-body font-medium text-[16px] text-orla-bone" data-id="element-300">
            Rated 4.8 from 6,000+ reviews
          </span>
        </div>

        {/* Pull Quote */}
        <div className="max-w-[820px] mx-auto mb-20" data-id="element-301">
          <p className="font-display italic text-[22px] md:text-[28px] text-orla-bone leading-[1.4] text-center mb-5" data-id="element-302">
            "Orla is doing what mainstream medicine has refused to — taking
            perimenopause seriously, and treating women like adults."
          </p>
          <p className="font-body font-medium text-[14px] text-orla-saffron text-center" data-id="element-303">
            — Vogue
          </p>
        </div>

        {/* Press Marquee */}
        <div className="w-full overflow-hidden" data-id="element-304">
          <div className="flex w-max animate-marquee hover:[animation-play-state:paused] items-center gap-16" data-id="element-305">
            {logos.map((logo, index) => <div key={index} className="font-body font-bold text-[14px] md:text-[16px] uppercase tracking-wider text-orla-bone opacity-80 hover:opacity-100 transition-opacity duration-200 whitespace-nowrap" data-id="element-306">
                {logo}
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}